import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=44790300&scoped=true"
import script from "./FileDetail.vue?vue&type=script&lang=js"
export * from "./FileDetail.vue?vue&type=script&lang=js"
import style0 from "./FileDetail.vue?vue&type=style&index=0&id=44790300&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44790300",
  null
  
)

export default component.exports